/* Super Socks – Karten auf der Produktseite
 *
 * Öffnet die Karten aus snippets/ss-karten.liquid:
 *   - [data-ss-karte="onesize"]: Fragezeichen an der Kachel ONE SIZE. Der Knopf
 *     „ONE SIZE wählen“ wählt die Größe über die echte Kachel aus, damit Preis,
 *     Bild und Verfügbarkeit wie beim Antippen der Kachel mitwechseln.
 *   - [data-ss-karte="lieferzeit"]: Infozeichen der Lieferzeile. Das Datum wird
 *     beim Öffnen aus der Lieferzeile übernommen, die Berechnung bleibt beim Theme.
 * Schließen: Kreuz, dunkler Hintergrund, Escape, am Handy nach unten wischen.
 */
(function () {
  'use strict';
  if (window.SSKarten) return;

  var offen = null;
  var ausloeser = null;

  function karte(id) {
    return document.getElementById('ss-karte-' + id);
  }

  /* Karten an das Ende von body hängen: so wirken Zuschnitt und Ebenen der
     Produktspalte (Waterdrop-Effekt) nicht auf die fixierte Karte. */
  function vorbereiten() {
    var ks = document.querySelectorAll('.ss-karte');
    for (var i = 0; i < ks.length; i++) {
      if (ks[i].parentNode !== document.body) document.body.appendChild(ks[i]);
    }
  }

  function lieferzeitFuellen(k, von) {
    var msg = (von && von.closest && von.closest('.stock-msg')) ||
      document.querySelector('.is-product-main .stock-msg.d-flex');
    var zeile = k.querySelector('[data-ss-lieferung]');
    if (!msg) return;
    var klon = msg.cloneNode(true);
    var weg = klon.querySelectorAll('.info-msg, .ss-info-knopf, svg, script, style, button');
    for (var i = 0; i < weg.length; i++) weg[i].parentNode.removeChild(weg[i]);
    if (zeile) {
      zeile.textContent = klon.textContent.replace(/\s+/g, ' ').trim();
      zeile.classList.toggle('is-aus', msg.classList.contains('out-of-stock'));
    }
  }

  function oneSizeVorbereiten(k) {
    var knopf = k.querySelector('[data-ss-onesize-waehlen]');
    var kachel = document.querySelector('.is-product-main .swatch-element.one-size-swatch');
    if (knopf) knopf.hidden = !kachel || kachel.classList.contains('soldout');
  }

  function fokussierbar(k) {
    return [].filter.call(
      k.querySelectorAll('a[href], button:not([hidden]), [tabindex]:not([tabindex="-1"])'),
      function (e) { return e.offsetParent !== null; }
    );
  }

  function oeffnen(id, von) {
    var k = karte(id);
    if (!k) return false;
    if (offen) schliessen(true);
    if (id === 'lieferzeit') lieferzeitFuellen(k, von);
    if (id === 'onesize') oneSizeVorbereiten(k);
    ausloeser = von || null;
    k.setAttribute('aria-hidden', 'false');
    k.classList.add('is-offen');
    document.documentElement.classList.add('ss-karte-offen');
    offen = k;
    var zu = k.querySelector('[data-ss-zu]');
    setTimeout(function () { if (zu) zu.focus({ preventScroll: true }); }, 40);
    return true;
  }

  function schliessen(ohneFokus) {
    if (!offen) return;
    offen.classList.remove('is-offen');
    offen.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ss-karte-offen');
    offen = null;
    if (!ohneFokus && ausloeser && ausloeser.focus) ausloeser.focus({ preventScroll: true });
    ausloeser = null;
  }

  function oneSizeWaehlen() {
    var label = document.querySelector('.is-product-main .swatch-element.one-size-swatch label');
    schliessen(true);
    if (label) label.click();
  }

  /* Klicks in der Fangphase: so wählt das Fragezeichen in der Kachel nicht
     zugleich die Größe aus, und Theme-Skripte sehen den Klick nicht. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('[data-ss-karte]');
    if (a && karte(a.getAttribute('data-ss-karte'))) {
      e.preventDefault();
      e.stopPropagation();
      oeffnen(a.getAttribute('data-ss-karte'), a);
      return;
    }
    if (!offen) return;
    if (t.closest('[data-ss-zu]')) { e.preventDefault(); schliessen(); return; }
    if (t.closest('[data-ss-onesize-waehlen]')) { e.preventDefault(); oneSizeWaehlen(); return; }
    if (t === offen) schliessen();
  }, true);

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (offen) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); schliessen(); return; }
      if (e.key === 'Tab') {
        var f = fokussierbar(offen);
        if (!f.length) return;
        var erst = f[0], letzt = f[f.length - 1];
        if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
        else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
        else if (!offen.contains(document.activeElement)) { e.preventDefault(); erst.focus(); }
      }
      return;
    }
    /* Das Fragezeichen ist ein span in der Kachel: Enter und Leertaste selbst bedienen */
    if ((e.key === 'Enter' || e.key === ' ') && t && t.matches && t.matches('[data-ss-karte][role="button"]')) {
      e.preventDefault();
      e.stopPropagation();
      oeffnen(t.getAttribute('data-ss-karte'), t);
    }
  }, true);

  /* Am Handy: Karte nach unten wischen schließt sie (nicht bei data-ss-kein-wischen,
     z. B. der Empfehlungskarte: dort wird gescrollt) */
  var startY = null;
  document.addEventListener('touchstart', function (e) {
    if (!offen || offen.hasAttribute('data-ss-kein-wischen') || !e.target.closest || !e.target.closest('.ss-karte__blatt')) { startY = null; return; }
    startY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (startY === null || !offen) return;
    var dy = e.changedTouches[0].clientY - startY;
    var blatt = offen.querySelector('.ss-karte__blatt');
    if (dy > 70 && (!blatt || blatt.scrollTop <= 0)) schliessen();
    startY = null;
  }, { passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vorbereiten);
  else vorbereiten();

  window.SSKarten = { oeffnen: oeffnen, schliessen: schliessen };
})();
